import React, { useState } from "react";
import PinInput from "react-pin-input";
import Button from "../SelectValue/Button";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import postService from "../../Services/post-service";
import Loading from "../SelectValue/Loading";
import Shimmer from '../SelectValue/Shimmer';

export default function ConfirmPin() {
  const oldPin = localStorage.getItem("currentpin");
  const newPin = localStorage.getItem("newpin");
  const [loading, setLoading] = useState(false);
  const navigator = useNavigate();
  const [pin, setPin] = useState("");
  const onSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    if (pin.length === 4) {
      setLoading(true);
      if (newPin === pin) {
        postService.changePin(pin, oldPin).then(
          (response) => {
            if (response.data.statusCode === 200) {
              setLoading(false);
              toast.success(response.data.description || "Pin changed successfully");
            } else {
              setLoading(false);
              toast.error(response.data.description || "Failed to change pin");
            }
          },
          (error) => {
            setLoading(false);
            toast.error(error.response?.data?.description || "An error occurred");
          }
        );
      } else {
        toast.error("Pin not a match");
      }
    } else {
      setLoading(false);
      toast.error("Pin should be 4 digit");
    }
  };

  return (
    <div className=" mt-10 ">
      {loading ? (
        <div className='mt-5'>
          {/* <p className=' text-[18px] text-back-color2 mb-5  font-[500]'>Confirming PIN...</p> */}
          <Shimmer type="rect" />
          <div className='mt-4'>
            <Shimmer type="text" />
          </div>
        </div>
      ) : (
        <>
          <p className=" mb-3 text-back-color2">Confirm your new Zouse PIN</p>
          <div className="  mt-5">
            <div>
              <form onSubmit={onSubmit}>
                <div className=" w-full flex justify-center">
                  <PinInput
                    length={4}
                    initialValue={pin}
                    secret
                    onChange={(value, index) => {
                      setPin(value);
                    }}
                    type="numeric"
                    inputMode="number"
                    style={{ padding: "8px" }}
                    inputStyle={{
                      borderColor: "#00BC67",
                      backgroundColor: "#FAFBFC",
                      borderRadius: 8,
                    }}
                    inputFocusStyle={{
                      borderColor: "#00BC67",
                      backgroundColor: "#CCF2E1",
                    }}
                    onComplete={(value, index) => {
                      setPin(value);
                    }}
                    autoSelect={true}
                    regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                  />
                </div>

                <div className=" grid grid-cols-1 mb-5 mt-6">
                  <Button name="Change Pin" />
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
